import { makeStyles } from "@material-ui/core/styles";

export const useFiltersSkeletonStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 32,
    paddingRight: 16,
  },

  section: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },

  title: {
    width: 90,
    height: 14,
    borderRadius: 6,
    backgroundColor: "#eaeaea",
  },

  item: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },

  checkbox: {
    width: 20,
    height: 20,
    borderRadius: 6,
    backgroundColor: "#ededed",
    flexShrink: 0,
  },

  label: {
    height: 12,
    borderRadius: 6,
    backgroundColor: "#f1f1f1",
  },

  short: {
    width: "45%",
  },

  medium: {
    width: "65%",
  },

  seeMore: {
    width: 80,
    height: 12,
    borderRadius: 6,
    backgroundColor: "#e5f4d9",
    marginLeft: 32,
  },
}));
